import { RESET_DATASET } from 'store';

import { SET_PRIMARY_PARAMETER_LEVEL } from './types';
import { RESET_RANDOMIZATION_HYPOTHESIS_TESTING } from '../types';

export default (state = null, action) => {
  switch (action.type) {
    case SET_PRIMARY_PARAMETER_LEVEL:
      return action.primaryParameterLevel;
    case RESET_DATASET:
    case RESET_RANDOMIZATION_HYPOTHESIS_TESTING:
      return null;
    default:
      return state;
  }
};
